import { render } from "./EditPassword.vue?vue&type=template&id=0e951b30&scoped=true"
import script from "./EditPassword.vue?vue&type=script&lang=js"
export * from "./EditPassword.vue?vue&type=script&lang=js"

import "./EditPassword.vue?vue&type=style&index=0&id=0e951b30&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e951b30"]])

export default __exports__